/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * Optimized for Angular 14+ and modern browsers (ES2017+).
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 * Zone.js is required by Angular itself.
 */
import 'zone.js/dist/zone'; // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

// Add global to window for compatibility
(window as any).global = window;

// Only include polyfills for features not supported in ES2017+ browsers
// IntersectionObserver for lazy loading directive
import 'intersection-observer';
